import { axios } from '@Root/API'

export const getArchived = params => {
	return axios.get('archived-contact/index', { params })
}
